import React from 'react';
import { Icon } from 'semantic-ui-react';

// Utility function for handling area deletion
export const handleDeleteArea = (area, category, setAreaSelected, setConfirmDeleteArea, setConfirmDeleteAreaWithoutFields) => {
  setAreaSelected({
    ...area,
    cashflowCategoryId: category.cashflowCategoryId,
    cashflowCategoryName: category.label,
  });
  // Check if area has data (you might need to implement this logic)
  const hasData = false; // Placeholder - implement actual logic
  if (hasData) {
    setConfirmDeleteArea(true);
  } else {
    setConfirmDeleteAreaWithoutFields(true);
  }
};

const DeleteAreaModal = ({ 
  areaSelected
}) => {
  return (
    <div className="tw-space-y-6">
      {/* Header with warning */}
      <div className="tw-flex tw-items-center tw-gap-3 tw-pb-4 tw-border-b tw-border-gray-200">
        <div className="tw-p-2 tw-rounded-lg tw-bg-red-100">
          <Icon name="warning circle" color="red" size="large" />
        </div>
        <div>
          <h3 className="tw-text-lg tw-font-semibold tw-text-gray-900">
            Eliminar área
          </h3>
          <p className="tw-text-sm tw-text-gray-600">
            Confirmar eliminación
          </p>
        </div>
      </div>

      {/* Warning message */}
      <div className="tw-bg-red-50 tw-p-4 tw-rounded-lg tw-border tw-border-red-200">
        <div className="tw-flex tw-items-start tw-gap-3">
          <Icon name="warning circle" color="red" size="large" />
          <div>
            <h4 className="tw-text-sm tw-font-medium tw-text-red-800">
              ¿Estás seguro que quieres eliminar esta área?
            </h4>
            <p className="tw-text-sm tw-text-red-700 tw-mt-1">
              El área <span className="tw-font-semibold">{areaSelected?.label}</span> será eliminada permanentemente.
            </p>
            <p className="tw-text-xs tw-text-red-600 tw-mt-2">
              Esta acción no se puede deshacer.
            </p>
          </div>
        </div>
      </div>

      {/* Area details */}
      {areaSelected && (
        <div className="tw-bg-gray-50 tw-p-3 tw-rounded-lg">
          <div className="tw-space-y-2">
            <p className="tw-text-sm tw-text-gray-700">
              <span className="tw-font-medium">Área:</span> {areaSelected.label}
            </p>
            <p className="tw-text-sm tw-text-gray-700">
              <span className="tw-font-medium">Categoría:</span> {areaSelected.cashflowCategoryName || 'Sin categoría'}
            </p>
            <p className="tw-text-sm tw-text-gray-700">
              <span className="tw-font-medium">Tipo:</span> {areaSelected.isIncome ? 'Ingresos' : 'Egresos'}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteAreaModal; 